import React, { useState, useEffect } from 'react';
import { Typography, Input, Select, message, Form, Descriptions, Divider, Space, Row, Col, Tabs, Table } from 'antd';
import useWebPost from '../../utils/useWebPost';
import { checkp, dayjsDate, formatDate2, formatNumber, getAdmin, getobjkeys, getJsfs, getyhzh } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import { useNavigate, useParams } from 'react-router-dom';
import renderFileList from '../../components/renderFileList';

const { Text } = Typography;
const { Option } = Select;

const ExpenditureDetails = ({ item, lyDate  }) => {
    const { id } = useParams();
    const webPost = useWebPost();
    const [data, setData] = useState(null);
    const [szList, setszList] = useState([]);
    const [szList2, setszList2] = useState([]);
    useEffect(() => {
        setszList(null);
        setszList2(null);
        if (item) {
            setData(item);
        } else {
            async function getXx(s) {
                const res = await webPost('getCwExpBySn', { id: s });
                if (res) {
                    setData(res);
                }
            }
            if (id) {
                getXx(id);
            }
        }
        return undefined;
    }, [id, item]);
    useEffect(() => {
        const fxs = async () => {
            if (data) {
                const res = await webPost('getCkzcList', { id: data.id });
                if (res) {
                    if(lyDate)lyDate(res);
                    if(res?.ly && res.ly.length===0){
                        setszList(null);
                    }else{
                        setszList(res.ly);
                    }
                    if(res?.fl && res.fl.length===0){
                        setszList2(null);
                    }else{
                        setszList2(res.fl);
                    }
                }
            }
        };
        fxs();
        return undefined;
    }, [data]);
    if (data === null) return (<></>);
    const {
        sn,
        receipt_company,
        receipt_account,
        maker_name,
        make_date,
        income_type,
        settlement_method,
        payer_name,
        payer_account,
        payer_bank,
        km, kmmc,
        remark,
        this_receipt_amount,
        xmmc,
        contract_amount,
        invoiced_amount,
        received_amount,
        attachment,
        received_kpj,
        paid_amount,
        pay_type
    } = data;
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={null}
        >
            <div style={{ padding: '6px 12px', background: '#fff' }}>
                <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    付款方信息
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                    style={{ marginBottom: 24 }}
                >
                    <Descriptions.Item label="付款单位">{receipt_company}</Descriptions.Item>
                    <Descriptions.Item label="付款账号">{receipt_account}</Descriptions.Item>
                    <Descriptions.Item label="制单人">{maker_name}</Descriptions.Item>
                    <Descriptions.Item label="制单日期">{make_date}</Descriptions.Item>
                </Descriptions>

                {/* 付款方信息 */}
                <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    收款方信息
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                    style={{ marginBottom: 24 }}
                >
                    <Descriptions.Item label="收款户名">{payer_name}</Descriptions.Item>
                    <Descriptions.Item label="收款账号">{payer_account}</Descriptions.Item>
                    <Descriptions.Item label="收款银行">{payer_bank}</Descriptions.Item>
                    <Descriptions.Item label="支付类别">{pay_type}</Descriptions.Item>
                    <Descriptions.Item label="结算方式">{settlement_method}</Descriptions.Item>

                    <Descriptions.Item label="费用科目">
                        {km && (
                            <Space>
                                <Text code>{km}</Text>
                                <Text type="secondary">
                                    {kmmc}
                                </Text>
                            </Space>
                        )}
                    </Descriptions.Item>

                    <Descriptions.Item label="备注" span={3}>
                        {remark || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="合同总额">¥ {contract_amount}</Descriptions.Item>
                    <Descriptions.Item label="已收开票金额">¥ {received_kpj}</Descriptions.Item>
                    <Descriptions.Item label="付款金额">¥ {this_receipt_amount}</Descriptions.Item>
                </Descriptions>
                <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    付款来源信息
                </Divider>
                {szList && <Table  rowKey="id" dataSource={szList} footer={null} pagination={false} columns={[
                    {
                        title: '支付来源', dataIndex: 'ps', render: (t) => {
                            if (t.includes('个人来款')) {
                                return '个人来款';
                            }
                            if (t.includes('建设单位来款')) {
                                return '建设单位来款';
                            }
                            if (t.includes('资金垫付')) {
                                return '资金垫付';
                            }
                        }
                    },
                    {
                        title: '来源对象(日期-科目-当前余额)', dataIndex: 'ps', render: (_, it) => {
                            if (it.ps.includes('资金垫付')) {
                                return `${it.kmmc}-${it.left_amount}`;
                            }
                            return `${it.make_date}-${it.kmmc}-${it.left_amount}`;
                        }
                    },
                    { title: '支付金额', dataIndex: 'amount' },
                    { title: '银行账号', dataIndex: 'account' },

                ]} ></Table>
                }
                {szList2 && <>
                    <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        资金分流信息
                    </Divider>
                    <Table  rowKey="id" dataSource={szList2} footer={null} pagination={false} columns={[
                        { title: '转入项目', dataIndex: 'xmmc', render: (t, rs) => `${rs.sn}……${rs.xmmc}` },
                        { title: '科目', dataIndex: 'ps', render: (_, it) => `${it.km}-${it.kmmc}` },
                        { title: '转入金额', dataIndex: 'this_receipt_amount' },
                        { title: '银行账号', dataIndex: 'account' },

                    ]} ></Table>
                </>}
                {/* 金额与项目信息 */}
                <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    业务明细
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                >
                    <Descriptions.Item label="项目编号">{sn}</Descriptions.Item>
                    <Descriptions.Item label="项目名称">{xmmc}</Descriptions.Item>
                    <Descriptions.Item label="合同来款合计">¥ {received_amount}</Descriptions.Item>
                    <Descriptions.Item label="合同已付款合计">¥ {paid_amount}</Descriptions.Item>
                    <Descriptions.Item label="合同余额">¥ {invoiced_amount}</Descriptions.Item>
                </Descriptions>

                {/* 附件展示 */}
                {attachment && attachment.length > 0 && (
                    <>
                        <Divider titlePlacement="left" style={{ marginTop: 24 }}>附件</Divider>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                            {renderFileList(attachment)}
                        </div>
                    </>
                )}
            </div>
        </FullHeightLayout >
    );
};

export default ExpenditureDetails;